import {UyapDigerEvrakTuru} from "@/plugins/uyap-plugin/enum/uyap/evrak/UyapDigerEvrakTuru";

export interface ZorunluAlan {
    /** borclu.digerTalep[paramsKey] içindeki alan adı */
    key: string;
    /** Kullanıcıya gösterilecek ad; talep formundaki etiketle aynı olmalı */
    label: string;
}

export interface TalepZorunluTanim {
    paramsKey: string;
    alanlar: Array<ZorunluAlan>;
}

/**
 * Genel talep formlarındaki zorunlu alanların tek kaynağı.
 *
 * ID taşıyan alanlarda (malTip, birimId, belgeTip, kapanmaId) 0 UYAP'ta geçerli bir
 * değer olabildiği için "seçim yapıldı mı" kontrolü, seçimle birlikte dolan metin
 * eşine (malTipAciklama, birimAdi, ...) bakılarak yapılır. Metin eşi olmayan
 * calismaDurumu'nda ise varsayılan null'dur.
 */
export const DIGER_TALEP_ZORUNLU_ALANLAR: Record<number, TalepZorunluTanim> = {
    [UyapDigerEvrakTuru.aciz_belgesi_hazirlanmasi]: {
        paramsKey: "acizBelgesiHazirlanmasiParams",
        alanlar: [{key: "aciklama", label: "Açıklama"}]
    },
    [UyapDigerEvrakTuru.arac_uzerindeki_haciz_serhinin_kaldirilmasi]: {
        paramsKey: "aracUzerindekiHacizSerhininKaldirilmasiParams",
        alanlar: [{key: "plaka", label: "Plaka"}]
    },
    [UyapDigerEvrakTuru.arac_uzerindeki_yakalama_serhinin_kaldirilmasi]: {
        paramsKey: "aracUzerindekiYakalamaSerhininKaldirilmasiParams",
        alanlar: [{key: "plaka", label: "Plaka"}]
    },
    [UyapDigerEvrakTuru.bankadan_hacizli_paranin_istenilmesi]: {
        paramsKey: "bankadanHacizliParaninIstenilmesiParams",
        alanlar: [
            {key: "hacizTarihi", label: "Haciz Tarihi"},
            {key: "bankaList", label: "Banka"},
            {key: "aciklama", label: "Açıklama"}
        ]
    },
    [UyapDigerEvrakTuru.borclu_tarafindan_yapilan_odemelerin_hesaba_aktarilmasi]: {
        paramsKey: "borclutarafindanYapilanOdemelerinHesabaAktarilmasiParams",
        alanlar: [
            {key: "hesapKimeAit", label: "Hesap Kime Ait"},
            {key: "ibanNo", label: "IBAN No"}
        ]
    },
    [UyapDigerEvrakTuru.dosyada_hacizli_malin_satisi]: {
        paramsKey: "dosyadaHacizliMalinSatisiParams",
        alanlar: [
            {key: "hacizTarihi", label: "Haciz Tarihi"},
            {key: "malTipAciklama", label: "Mal Türü"},
            {key: "aciklama", label: "Açıklama"}
        ]
    },
    [UyapDigerEvrakTuru.dosyadaki_avansin_iadesi]: {
        paramsKey: "dosyadakiAvansinIadesiParams",
        alanlar: [
            {key: "hesapKimeAit", label: "Hesap Kime Ait"},
            {key: "ibanNo", label: "IBAN No"}
        ]
    },
    [UyapDigerEvrakTuru.dosyadaki_hacizlerin_kaldirilmasi]: {
        paramsKey: "dosyadakiHacizlerinKaldirilmasiParams",
        alanlar: [{key: "aciklama", label: "Açıklama"}]
    },
    [UyapDigerEvrakTuru.dosyadaki_IBAN_bilgisinin_guncellenmesi]: {
        paramsKey: "ibanGuncellemeParams",
        alanlar: [
            {key: "hesapKimeAit", label: "Hesap Kime Ait"},
            {key: "ibanNo", label: "IBAN No"}
        ]
    },
    [UyapDigerEvrakTuru.dosyanin_islemden_kaldirilmasi]: {
        paramsKey: "dosyaninIslemdenKaldirilmasiParams",
        alanlar: [
            {key: "kapanmaAdi", label: "Kapanış Nedeni"},
            {key: "aciklama", label: "Açıklama"}
        ]
    },
    [UyapDigerEvrakTuru.dosyanin_yetkili_icra_dairesine_gonderilmesi]: {
        paramsKey: "dosyaninYetkiliIcraDairesineGonderilmesiParams",
        alanlar: [
            {key: "birimAdi", label: "İcra Dairesi"},
            {key: "aciklama", label: "Açıklama"}
        ]
    },
    [UyapDigerEvrakTuru.hacizli_malin_kiymet_takdiri_icin_talimat_yazilmasi]: {
        paramsKey: "hacizliMalinKiymetTakdiriIcinTalimatYazilmasiParams",
        alanlar: [
            {key: "hacizTarihi", label: "Haciz Tarihi"},
            {key: "malTipAciklama", label: "Mal Türü"},
            {key: "birimAdi", label: "İcra Dairesi"},
            {key: "aciklama", label: "Açıklama"}
        ]
    },
    [UyapDigerEvrakTuru.hacizli_malin_satisi_icin_talimat_yazilmasi]: {
        paramsKey: "hacizliMalinSatisiIcinTalimatYazilmasiParams",
        alanlar: [
            {key: "hacizTarihi", label: "Haciz Tarihi"},
            {key: "malTipAciklama", label: "Mal Türü"},
            {key: "birimAdi", label: "İcra Dairesi"},
            {key: "aciklama", label: "Açıklama"}
        ]
    },
    [UyapDigerEvrakTuru.hacizli_tasinir_mallarin_muhafaza_altina_alinmasi]: {
        paramsKey: "hacizliTasinirMallarinMuhafazaAltinaAlinmasiParams",
        alanlar: [{key: "hacizTarihi", label: "Haciz Tarihi"}]
    },
    [UyapDigerEvrakTuru.haricen_tahsilat_bildirimi]: {
        paramsKey: "haricenTahsilatBildirimiParams",
        alanlar: [
            {key: "tahsilatTarihi", label: "Tahsilat Tarihi"},
            {key: "aciklama", label: "Açıklama"}
        ]
    },
    [UyapDigerEvrakTuru.iIK121_maddeye_gore_yetki_verilmesi]: {
        paramsKey: "iik121MaddeyeGoreYetkiVerilmesiParams",
        alanlar: [{key: "aciklama", label: "Açıklama"}]
    },
    [UyapDigerEvrakTuru.iIK150C_serhi_eklenmesi]: {
        paramsKey: "iik150cSerhiEklenmesiParams",
        alanlar: [{key: "aciklama", label: "Açıklama"}]
    },
    [UyapDigerEvrakTuru.kiymet_takdirinin_yapilmasi]: {
        paramsKey: "kiymetTakdirininYapilmasiParams",
        alanlar: [
            {key: "hacizTarihi", label: "Haciz Tarihi"},
            {key: "malTipAciklama", label: "Mal Türü"},
            {key: "aciklama", label: "Açıklama"}
        ]
    },
    [UyapDigerEvrakTuru.maas_uzerindeki_hacizlerin_kaldirilmasi]: {
        paramsKey: "maasUzerindekiHacizlerinKaldirilmesiParams",
        alanlar: [
            {key: "calismaDurumu", label: "Çalışma Durumu"},
            {key: "aciklama", label: "Açıklama"}
        ]
    },
    [UyapDigerEvrakTuru.muhafaza_altindaki_mallarin_haciz_baki_kalarak_yeddiemin_degisikligi]: {
        paramsKey: "muhafazaAltindakiMallarinHacizBakiKalarakYeddieminDegisikligiParams",
        alanlar: [
            {key: "muhafazaTarihi", label: "Muhafaza Tarihi"},
            {key: "yeddiemin", label: "Yeddiemin"},
            {key: "aciklama", label: "Açıklama"}
        ]
    },
    [UyapDigerEvrakTuru.rehin_acigi_belgesi_hazirlanmasi]: {
        paramsKey: "rehinAcigiBelgesiHazirlanmasiParams",
        alanlar: [{key: "belgeTipAciklama", label: "Belge Tipi"}]
    },
    [UyapDigerEvrakTuru.rehinin_paraya_cevrilmesi_serhi]: {
        paramsKey: "rehininParayaCevrilmesiSerhiParams",
        alanlar: [{key: "aciklama", label: "Açıklama"}]
    },
    [UyapDigerEvrakTuru.tasinmaz_haczinin_kaldirilmasi]: {
        paramsKey: "tasinmazHaczininKaldirilmasiParams",
        alanlar: [
            {key: "hacizTarihi", label: "Haciz Tarihi"},
            {key: "aciklama", label: "Açıklama"}
        ]
    },
    [UyapDigerEvrakTuru.yuzuncu_maddeye_yarar_bilgi_istenilmesi]: {
        paramsKey: "yuzuncuMaddeyeYararBilgiIstenilmesiParams",
        alanlar: [
            {key: "malTipAciklama", label: "Mal Türü"},
            {key: "aciklama", label: "Açıklama"}
        ]
    }
};

function doluMu(deger: any): boolean {
    if (deger === null || deger === undefined)
        return false;
    if (Array.isArray(deger))
        return deger.length > 0;
    if (typeof deger === "string")
        return deger.trim().length > 0;
    return true;
}

/** Verilen talep için borçluda eksik olan zorunlu alanların etiketleri. */
export function talepEksikAlanlari(borclu: any, talepKodu: number): Array<string> {
    let tanim = DIGER_TALEP_ZORUNLU_ALANLAR[talepKodu];
    if (!tanim)
        return [];
    let params = borclu && borclu.digerTalep ? borclu.digerTalep[tanim.paramsKey] : null;
    if (!params)
        return tanim.alanlar.map(alan => alan.label);
    return tanim.alanlar.filter(alan => !doluMu(params[alan.key])).map(alan => alan.label);
}

export interface TalepEksigi {
    talepKodu: number;
    alanlar: Array<string>;
}

/** Borçlunun seçili taleplerindeki tüm eksikler. Boş dizi = gönderime hazır. */
export function borcluEksikleri(borclu: any, talepKodlari: Array<number>): Array<TalepEksigi> {
    return talepKodlari
        .map(talepKodu => ({talepKodu, alanlar: talepEksikAlanlari(borclu, talepKodu)}))
        .filter(eksik => eksik.alanlar.length > 0);
}
